<template>
  <div>
    <modal-template v-show="toggle" @close="closeModal" class="override-modal">
      <template #header>
        <i class="icon-ic_close" @click="closeModal" />
        <h3>Situação da solicitação de cirurgia</h3>
      </template>
      <template #body>
        <div class="timeline-container has-text-centered" />
        <br />
        <p>
          <!-- STATUS: AGENDADA -->
          <status-agendada-content
            v-if="cirurgia.StatusCirurgia.toUpperCase() === 'AGENDADO'"
            :cirurgia="cirurgia"
          />
          <!-- STATUS: LISTA DE ESPERA -->
          <status-lista-de-espera-content
            v-else-if="
              cirurgia.StatusCirurgia.toUpperCase() === 'NA FILA DE ESPERA'
            "
            :cirurgia="cirurgia"
          />
          <!-- STATUS: NÃO MAPEADO -->
          <status-content v-else :cirurgia="cirurgia" />
        </p>
        <br />
        <br />
        <div class="msg-lido">
          Informações visualizadas em {{ cirurgia.DtAcesso | toDate }} às
          {{ cirurgia.DtAcesso | toHr }}
        </div>
      </template>
      <template #footer>
        <div class="absence">
          <b-button
            class="column button button-secondary confirm"
            @click="entendi()"
          >
            {{ $t('cirurgias.situacao_modal.botao_ok') }}
          </b-button>
          <br />
          <b-button
            class="column button cancel"
            @click="goToFaleConosco(cirurgia)"
          >
            {{ $t('cirurgias.situacao_modal.botao_fale_conosco') }}
          </b-button>
        </div>
      </template>
    </modal-template>
  </div>
</template>

<script>
import ModalTemplate from '../../modal/ModalTemplate'
import StatusAgendadaContent from './status/StatusAgendadaContent'
import StatusListaDeEsperaContent from './status/StatusListaDeEsperaContent'
import StatusContent from './status/StatusContent'
import { format } from 'date-fns'

export default {
  name: 'StatusCirurgiaModal',
  components: {
    ModalTemplate,
    StatusAgendadaContent,
    StatusListaDeEsperaContent,
    StatusContent
  },
  data() {
    return {}
  },
  props: {
    toggle: {
      type: Boolean,
      default: false
    },
    cirurgia: {
      type: Object,
      default: null
    }
  },
  methods: {
    entendi() {
      this.$emit('entendi')
      this.closeModal()
    },

    closeModal() {
      this.$emit('update:toggle', false)
    },

    goToFaleConosco(cirurgia) {
      this.$emit('update:toggle', false)
      this.$router.push({
        name: 'FaleConoscoCirurgias',
        params: {
          cirurgia: cirurgia
        }
      })
    }
  },
  filters: {
    toDate(value) {
      return format(new Date(value), 'dd/MM/yyyy')
    },
    toHr(value) {
      return format(new Date(value), 'HH:mm')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.absence {
  margin-bottom: 4px;
  margin: 0 auto;
  width: 90%;

  .confirm {
    margin: auto;
    width: 12.5rem;
  }

  .cancel {
    margin: auto;

    color: var(--light-blue);
    font-weight: 500;
    font-size: 0.875rem;
    height: 2.5rem;
    width: 12.5rem;
  }
}

.msg-lido {
  text-align: right;

  color: var(--neutral-color-3);
  font-size: 0.8rem;
  font-style: italic;
  padding: 0 3px;
}
</style>
